import { MapLocation } from "@/components/shared";
import { Property } from "@/types/property";

interface PropDetailsMapProps {
  property: Property;
}

const PropDetailsMap = ({ property }: PropDetailsMapProps) => {
  if (!property?.address) return null;

  return (
    <div className="mt-6">
      <h3 className="font-bold text-base text-main-900 mb-3">Location</h3>
      <MapLocation
        address={`${property.address}, ${property?.city || ""}, ${property?.state || ""}, Nigeria`}
      />
    </div>
  );
};

export default PropDetailsMap;
